<div class="max-h-full flex flex-col">

  <div [ngClass]="cssService.toolbarBgDashboardClass" class="p-4">

    <div *ngIf="currComp === 'select'">
      <div class="flex flex-row justify-between">

        <span class="text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins">{{'adressComponent.addresses' | translate}} </span>

        <span class="mat-subheading-1 primary-ico boldest clicked"
              (click)=" changeComp('create')"> {{'adressComponent.add' | translate}}</span>
      </div>
    </div>

    <div *ngIf="currComp === 'create' || currComp === 'update'">
      <div fxLayout="row" fxLayoutAlign="space-between center">
      <span
        class="mat-headline boldest">{{(addressToUpdate ? "adressComponent.changeAdress" : "adressComponent.newaddress")|translate}}</span>
      </div>
    </div>

  </div>

  <!-- Selection adresse -->
  <div *ngIf="currComp === 'select'" class="h-full flex-1 flex flex-col scrolled-y">

    <div fxLayout="column" fxLayoutGap="10px" *ngIf="clientAddresses && clientAddresses.length >0" class="contentmat">

      <div fxLayout="row" fxLayoutAlign="center center"
           [ngClass]="cssService.sectionCardClass"
           [class.back]="add.is_default && cometoaccount" *ngFor="let add of clientAddresses;"
           (click)="selectAddress(add)">

        <!-- Radio btn -->
        <div fxLayoutAlign="center center" style="padding: 10px;" *ngIf="!cometoaccount">
          <div class="fake-radio"
               *ngIf="selectedAddress && selectedAddress.address_id !== add.address_id || !selectedAddress"></div>
          <div class="fake-radio primary" fxLayoutAlign="center center"
               *ngIf="selectedAddress && selectedAddress.address_id === add.address_id"><i
            class="fas fa-check whited-ico"
            style="font-size: 10px;"></i></div>
        </div>

        <!-- Address content -->
        <div fxLayout="column" fxLayoutAlign="center start">

          <div fxLayout="row" fxLayoutAlign="start center">
            <span class="mat-caption boldest grey-ico">{{add.name |capitalize}}</span>
          </div>

          <div fxLayout="row" fxLayoutAlign="start center">
            <span class="mat-subheading-1" ngClass.xs="mat-caption">{{add.address | capitalize}}, {{add.postal}},
              {{add.city_name | uppercase}}</span>
          </div>

        </div>

        <div fxFlex></div>

        <!-- Icons (favoris, delete) -->
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <mat-icon fontSet="material-icons-outlined" *ngIf="add.is_default === 0"
                    (click)="setDefaultAddress(add);$event.stopPropagation();">star_rate
          </mat-icon>

          <mat-icon *ngIf="add.is_default === 1" (click)="setDefaultAddress(add);$event.stopPropagation();"
                    style="color:rgb(245, 245, 1);">star_rate
          </mat-icon>

          <mat-icon (click)="openDialDeletAddress(add.address_id);$event.stopPropagation();" class="warn-ico">
            delete_forever
          </mat-icon>
          <mat-icon (click)="changeComp('update',add);$event.stopPropagation();">
            edit
          </mat-icon>
        </div>

      </div>

    </div>

    <div fxLayout="column" class="contentnomat" fxLayoutAlign="center center"
         *ngIf="clientAddresses.length === 0 || !clientAddresses">
      <span class="mat-subheading-1">{{'adressComponent.addMessage' | translate}} </span>
    </div>
    <div fxFlex></div>

    <!-- Error message -->
    <div fxLayout="row" fxLayoutAlign="center center" class="warn rad-bord layout-padd" *ngIf="errorMessage">
      <span class="mat-subheading-1">{{errorMessage}}</span>
    </div>

  </div>

  <!-- Create comp  -->
  <div *ngIf="currComp === 'create' || currComp === 'update'" class="h-full flex-1 flex flex-col scrolled-y p-4">

    <!-- Formulaire -->
    <form fxLayout="column" fxLayoutGap="5px" [formGroup]="addressForm" (submit)="addorUpdateAddress()"
          #formDirective="ngForm" class="full-w">

      <!-- Physical and  moral -->
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" fxLayoutAlign="start center"
           style="padding-bottom: 20px;">

        <div fxFlex="50" ngClass.xs="full-w" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px"
             class="fake-form-field-endorder" (click)="setProfessional(0)">

          <div fxLayoutAlign="center center" style="padding-left: 10px;">
            <div class="fake-radio" *ngIf="addressForm.get('professional').value !== 0"></div>
            <div class="fake-radio primary" fxLayoutAlign="center center"
                 *ngIf="addressForm.get('professional').value === 0"><i class="fas fa-check whited-ico"
                                                                        style="font-size: 10px;"></i></div>
            <span class="mat-subheading-1 tght-line boldest">&nbsp;&nbsp;{{'adressComponent.part' | translate}}</span>
          </div>

          <mat-icon>person</mat-icon>

        </div>

        <div fxFlex="50" ngClass.xs="full-w" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px"
             class="fake-form-field-endorder" (click)="setProfessional(1)">

          <div fxLayoutAlign="center center" style="padding-left: 10px;">
            <div class="fake-radio" *ngIf="addressForm.get('professional').value !== 1"></div>
            <div class="fake-radio primary" fxLayoutAlign="center center"
                 *ngIf="addressForm.get('professional').value === 1">
              <i class="fas fa-check whited-ico" style="font-size: 10px;"></i>
            </div>
            <span class="mat-subheading-1 tght-line boldest">&nbsp;&nbsp;{{'adressComponent.soc' | translate}}</span>
          </div>

          <mat-icon>business</mat-icon>

        </div>

      </div>

      <!-- Address Name input -->
      <div fxLayout="column" fxLayoutGap="5px">

        <mat-form-field appearance="outline" class="full-w form-nopadd">
          <mat-label>{{'adressComponent.name' | translate}}</mat-label>
          <input type="text" matInput formControlName="name">
        </mat-form-field>

        <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('name')">
          <span class="mat-caption">{{'adressComponent.namerequired' | translate}}</span>
        </mat-error>
        <mat-error fxLayout fxLayoutAlign="start center" *ngIf="addressForm.get('name').hasError('nospace')">
          <span class="mat-caption">{{'adressComponent.invalidFormat' | translate}}</span>
        </mat-error>
      </div>

      <!-- Company activity taxe -->
      <div fxLayoutGap="5px" fxLayout="column" class="clicked" *ngIf="addressForm.get('professional').value === 1">

        <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px">

          <!-- company -->
          <mat-form-field fxFlex="50" appearance="outline" class="form-nopadd">
            <mat-label>{{'adressComponent.siret' | translate}} </mat-label>
            <input type="text" matInput formControlName="company_identification">
          </mat-form-field>

          <!-- Activity -->
          <mat-form-field fxFlex="50" appearance="outline" class="form-nopadd">
            <mat-label>{{'adressComponent.naf' | translate}}</mat-label>
            <input type="text" matInput formControlName="activity_identification">
          </mat-form-field>

        </div>

        <!-- taxe -->
        <mat-form-field appearance="outline" class="form-nopadd">
          <mat-label>{{'adressComponent.tva' | translate}}</mat-label>
          <input type="text" matInput formControlName="tax_identification">
        </mat-form-field>

      </div>

      <!-- Address input -->
      <div fxLayout="column" fxLayoutGap="5px">

        <mat-form-field appearance="outline" class="form-nopadd full-w">
          <mat-label>{{'adressComponent.address' | translate}}</mat-label>
          <input type="text" matInput formControlName="address">
        </mat-form-field>

        <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('address')">
          <span class="mat-caption">{{'adressComponent.addressrequired' | translate}}</span>
        </mat-error>
        <mat-error fxLayout fxLayoutAlign="start center" *ngIf="addressForm.get('address').hasError('nospace')">
          <span class="mat-caption">{{'adressComponent.invalidFormat' | translate}}</span>
        </mat-error>
      </div>


      <!-- Country -->
      <div fxLayout="column" fxLayoutGap="5px" fxFlex="30">

        <mat-form-field appearance="outline">
          <mat-label>{{'adressComponent.country' | translate}}</mat-label>


          <mat-select formControlName="country_name">

            <mat-option *ngFor="let country of filteredCountries" [value]="country.name"
                        (click)="setSelectedCountry(country)">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <img *ngIf="country.flag" src="data:image/png;base64,{{country.flag}}" class="h-8">
                <div *ngIf="!country.flag">
                  <mat-icon>outlined_flag</mat-icon>
                </div>
                <span>{{country.name | uppercase}}</span>
              </div>
            </mat-option>

          </mat-select>
        </mat-form-field>

        <!-- Postal input -->
        <div fxLayout="column" fxLayoutGap="5px" fxFlex="30">

          <mat-form-field appearance="outline" class="form-nopadd">

            <mat-label>{{'adressComponent.postalCode' | translate}}</mat-label>

            <input matInput autocomplete="none|false|no" formControlName="postal" (keydown.backspace)="removePostal()"
                   #inputPostal [attr.disabled]="'true'">


          </mat-form-field>

          <mat-error class="mat-caption"
                     *ngIf="unavailablePostal && addressForm.get('postal').value">{{'adressComponent.zipfalse' | translate}}</mat-error>

          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('postal')">
            <span class="mat-caption">{{'adressComponent.postalCoderequired' | translate}}</span>
          </mat-error>
        </div>

        <!-- City input -->
        <mat-form-field appearance="outline" class="form-nopadd">

          <mat-label>{{'adressComponent.city' | translate}}</mat-label>

          <mat-select formControlName="city_name" #selectCities>

            <mat-option *ngFor="let city of filteredCities" [value]="city.name"
                        (onSelectionChange)="onSelectCity($event,city)">
              {{city.name}}
            </mat-option>

          </mat-select>

        </mat-form-field>

      </div>

      <!-- Comment input -->
      <mat-form-field appearance="outline" class="form-nopadd">
        <mat-label>{{'adressComponent.comment' | translate}} </mat-label>
        <input type="text" matInput formControlName="comment">
      </mat-form-field>

      <!-- Checkbox default -->
      <div *ngIf="addressToUpdate" style="padding: 0 0 9px 0; padding: 10px 0 10px 0;">

        <!-- new  disabled to[disabled]-->
        <mat-checkbox color="primary" checked="flagDefault" [disabled]="true"
                      *ngIf="clientAddresses.length > 0 && addressToUpdate.is_default === 1"
                      formControlName="is_default">{{'adressComponent.adressDefault' | translate}}
        </mat-checkbox>

        <mat-checkbox color="primary" checked="flagDefault"
                      *ngIf="clientAddresses.length > 0  && addressToUpdate.is_default === 0"
                      formControlName="is_default">{{'adressComponent.adressDefault' | translate}}
        </mat-checkbox>

        <mat-checkbox color="primary" checked="true" disabled="true"
                      *ngIf="clientAddresses.length < 1">{{'adressComponent.adressDefault' | translate}}
        </mat-checkbox>

      </div>

      <div *ngIf="!addressToUpdate" style="padding: 0 0 9px 0; padding: 10px 0 10px 0;">

        <mat-checkbox color="primary" *ngIf="clientAddresses.length > 0"
                      formControlName="is_default">{{'adressComponent.adressDefault' | translate}}
        </mat-checkbox>

        <mat-checkbox color="primary" checked="true" disabled="true"
                      *ngIf="clientAddresses.length < 1">{{'adressComponent.adressDefault' | translate}}
        </mat-checkbox>

      </div>

      <!-- Error message -->
      <div fxLayout="row" fxLayoutAlign="center center" class="warn rad-bord layout-padd" *ngIf="errorMessage">
        <span class="mat-subheading-1">{{errorMessage}}</span>
      </div>

      <div fxFlex></div>

      <!-- Submit Button input -->
      <button type="submit" angulartics2On="click"
              [ngClass]="cssService.defaultPositiveDialogButton"
              angularticsAction="{{ addressToUpdate ? 'submitUpdate' : 'submitCreate'}}"
              angularticsCategory="billingAddresses" [disabled]="addressForm.invalid">
        <span>{{ (addressToUpdate ? 'adressComponent.update' : 'adressComponent.create')| translate}} </span>
      </button>

      <button type="submit" [ngClass]="cssService.defaultNegativeDialogButton"
              (click)="changeComp('select')">
        <span>{{"dialogs.go-back" | translate}}</span>
      </button>

    </form>
  </div>

  <!-- Buttons  -->
  <div *ngIf="currComp === 'select'">

    <div class="flex flex-col gap-2 p-4">

      <button [class.isDisabled]="!selectedAddress" [ngClass]="cssService.defaultPositiveDialogButton"
              (click)="closeDial(true)">
        <span>{{"button.validate" | translate}}</span>
      </button>

      <button [class.isDisabled]="selectedAddressdefaultchanged" [ngClass]="cssService.defaultNegativeDialogButton"
              (click)="closeDial()">
        <span>{{"dialogs.go-back" | translate}}</span>
      </button>

    </div>

  </div>

  <app-popup-loader [flagLoading]=" loaders.page" [size]="30">
  </app-popup-loader>

</div>
